export default "__VITE_ASSET__DI5g7W_u__"